import type { Meta, StoryObj } from '@storybook/angular';
import { expect, within } from 'storybook/test';
import { ProductBadgesComponent } from '../../../app/content/modules/page/components/product/components/product-badges/product-badges.component';
import { withCommonDecorators } from '../../_utils/story-helpers';
import { createDamilanoBarberaProduct, createLastBottlesProduct } from '../../_mocks/wine-product.mock';

const meta: Meta<ProductBadgesComponent> = {
  title: 'Molecules/Product/Product Badges',
  component: ProductBadgesComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
};
export default meta;
type Story = StoryObj<ProductBadgesComponent>;

export const InStock: Story = {
  args: { product: createDamilanoBarberaProduct({ inStock: true }) },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/på lager/i)).toBeInTheDocument();
  },
};

export const OutOfStock: Story = {
  args: { product: createDamilanoBarberaProduct({ inStock: false }) },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/udsolgt/i)).toBeInTheDocument();
  },
};

export const Preorder: Story = {
  args: {
    product: createDamilanoBarberaProduct({
      inStock: true,
      preorderDate: '2026-06-15T00:00:00Z',
      isEnPrimeur: false,
    }),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/forsalg/i)).toBeInTheDocument();
  },
};

export const EnPrimeur: Story = {
  args: {
    product: createDamilanoBarberaProduct({
      inStock: true,
      preorderDate: '2026-09-01T00:00:00Z',
      isEnPrimeur: true,
    }),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/en primeur/i)).toBeInTheDocument();
  },
};

export const CustomCtaStockText: Story = {
  args: {
    product: createDamilanoBarberaProduct({
      inStock: true,
      ctaStockText: 'Kun 5 flasker tilbage!',
      ctaLink: '/special-offer',
    }),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/kun 5 flasker tilbage/i)).toBeInTheDocument();
  },
};

export const LastBottles: Story = {
  args: {
    product: createLastBottlesProduct(),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/på lager/i)).toBeInTheDocument();
  },
};

export const HiddenAdvantages: Story = {
  args: {
    product: createDamilanoBarberaProduct({
      inStock: true,
      hideSupervinAdvantages: true,
    }),
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-badges')).toBeTruthy();
  },
};
